import { ref } from 'vue'
import { getTournament } from '@/helpers/tournament-helpers'
import type { Tournament } from '@/services/api'

const tournament = ref<Tournament | undefined>()
const isFetching = ref(false)

/**
 * get the participant id from the url
 * @return {Number}
 */
export function getTournamentId() {
  if (tournament.value) {
    return tournament.value.id
  }
  return undefined
}

export function useTournament() {
  async function fetchTournament(tournamentId: number): Promise<void> {
    // if we are already fetching a new tournament wait
    while (isFetching.value) {
      await new Promise((resolve) => setTimeout(resolve, 10))
    }

    // if we can not get an id, or the current retrieved tournament is the same as the one requested: return
    if (!tournamentId || tournamentId == tournament.value?.id) {
      return
    }

    isFetching.value = true
    try {
      tournament.value = await getTournament(tournamentId)
    } catch (error) {
      tournament.value = undefined
      console.error('Failed to fetch tournament:', error)
    } finally {
      // Fetch complete
      isFetching.value = false
    }
  }

  function setTournament(obj: Tournament) {
    tournament.value = obj
  }

  function getTournamentClubs() {
    const currentTournament = tournament.value
    if (currentTournament) {
      return currentTournament.clubs
        .map((item) => ({
          name: item.name,
          id: item.id
        }))
        .sort((a, b) => {
          if (a.name === 'Other') return 1
          if (b.name === 'Other') return -1
          return a.name.localeCompare(b.name)
        })
    }
    return []
  }

  return {
    tournament,
    setTournament,
    fetchTournament,
    getTournamentClubs
  }
}
